import { render, staticRenderFns } from "./DialogEditContact.vue?vue&type=template&id=2caebe03&scoped=true"
import script from "./DialogEditContact.vue?vue&type=script&lang=js"
export * from "./DialogEditContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caebe03",
  null
  
)

export default component.exports